import { useState } from 'react';
import useGlobalFilters from '../../../../hooks/useGlobalFilters';
import useTableMenu from '../../../../hooks/useTableMenu';
import useUserAccess from '../../../../hooks/useUserAccess';
import { getAccessValues } from '../../../../components/layout/RoutesManager/access';
import { showAlert, showRgrlDialogAlert } from '../../../../features/slices/applicationSlice';
import { useTranslation } from 'react-i18next';
import useTranslate from '../../../../hooks/useTranslate';
import {
    useGetRGRLVinculationPresentationsQuery,
    GenerateFilesBody,
    useGenerateFilesMutation,
    useGetRGRLVinculationContractsQuery,
    useGetRGRLVinculationEstablishmentsQuery,
    useLazyExportRGRLPresentationsQuery
} from '../../../../services/rgrlVinculationApi';
import useDownloadFile from '../../../../hooks/useDownloadFile';
import { PdfType } from '../../../Presentaciones/hooks/useReports';
// import { useLazyGetPresentacionRGRLPDFbyIdQuery } from '../../../../services/presentacionesApi';
import {
    downloadBase64File,
    getCurrentDate,
    getDateTextFieldFormat
} from '../../../../utils/common';
import { enqueueSnackbar } from 'notistack';
import { useAppDispatch, useAppSelector } from '../../../../hooks/reduxHooks';
import { ALERT_CONFIRM_TEXT, ERROR_CONTACT_SUPPORT } from '../../../../constants/values';
import dayjs from 'dayjs';
import { SRT_STATES } from '../../consts/states';
import { useRoles } from '../../../../hooks/useRoles';
import { useOrganizationFilter } from '../../../../contexts/OrganizationFilterContext';
import { buildRGRLExportParams, buildRGRLQueryParams } from '../utils/rgrlQueryParams';
import { useDownloadRGRLFilesOptionsDialog } from '../../../../components/Dialogs/DownloadRGRLFilesOptionsDialog';
import {
    esErrorGenericoGeneracion,
    obtenerMensajeRechazoGeneracion
} from '../../utils/erroresGeneracion';

const TITULO_ERROR_GENERACION = 'No se pudo generar los archivos SRT';

interface SelectedPresentation {
    id: number;
    estadoSRT: SRT_STATES;
}

const useFileGenerationRGRL = (handleCloseDrawer: any) => {
    const dispatch = useAppDispatch();
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    // Borrador de lo que se ve en el DateRangePicker: se mantiene separado de
    // startDate/endDate (los que realmente filtran la query) para no disparar
    // una búsqueda con un solo extremo del rango cargado.
    const [draftStartDate, setDraftStartDate] = useState<Date | null>(null);
    const [draftEndDate, setDraftEndDate] = useState<Date | null>(null);

    const [selectedItemFromAction, setSelectedItemFromAction] = useState<any>(null);
    const { isDownloading, downloadFile } = useDownloadFile();
    const { isPerfilBackOffice } = useRoles();
    const presentationUploadErrors = useAppSelector(
        (state) => state.srtPresentations.presentationUploadErrorLocationData
    );
    const [selected, setSelected] = useState<any | null>(null);
    const [selectedPresentations, setSelectedPresentations] = useState<SelectedPresentation[]>([]);

    const filters = useGlobalFilters();
    const { filters: baseFilters, extraFilters, setFilters, handleSubmitSearch } = filters;

    const { data: contractsOptions, isFetching: isFetchingContractsOptions } =
        useGetRGRLVinculationContractsQuery({ ...(isPerfilBackOffice ? extraFilters : {}) });

    const { data: establishmentsOptions, isFetching: isFetchingEstablishmentsOptions } =
        useGetRGRLVinculationEstablishmentsQuery(extraFilters);

    const { t } = useTranslation('filesGenerationSRT');
    const { translate } = useTranslate(t);

    const tableMenu = useTableMenu();
    const access = useUserAccess();
    const FEATURES = getAccessValues(access);

    const { handleOpenCard, anchorToEventElement, openMenu, closeMenu } = tableMenu;
    const { data: presentations, isFetching: isFetchingPresentations } =
        useGetRGRLVinculationPresentationsQuery(
            buildRGRLQueryParams(baseFilters, startDate, endDate)
        );
    const [generateFiles, { isLoading: isGeneretingFiles }] = useGenerateFilesMutation();
    const [triggerExportPresentations, { isFetching: isExportingPresentations }] =
        useLazyExportRGRLPresentationsQuery();
    const [isDownloadingPDF, setDownloadingPDF] = useState<boolean>(false);
    // const [triggerGetPresentacionRGRLPDFById, { isLoading: isLoadingRgrl }] =
    //     useLazyGetPresentacionRGRLPDFbyIdQuery();
    const { handleRGRLDownload, isFetchingPDFLink } = useDownloadRGRLFilesOptionsDialog();

    const { selectedOrganization } = useOrganizationFilter();

    const handleDownloadPresentation = async () => {
        try {
            // closeMenu();
            // setDownloadingPDF(true);
            if (
                !selectedItemFromAction?.id ||
                selectedItemFromAction?.tipo?.nombre !== PdfType.RGRL
            ) {
                enqueueSnackbar(translate('table.enqueues.error.downloadPDF'), {
                    variant: 'error'
                });
                return;
            }
            closeMenu();
            let fileName = `${
                selectedItemFromAction?.establecimiento?.nombre || 'Establecimiento'
            } - Cod SRT_${
                selectedItemFromAction?.establecimiento?.codigoSRT || 'CodigoSRT'
            } -  ${PdfType.RGRL}`;

            dispatch(
                showRgrlDialogAlert({
                    handleWithoutConformityClick: () =>
                        handleRGRLDownload(
                            selectedItemFromAction?.id,
                            fileName,
                            selectedItemFromAction,
                            selectedItemFromAction?.tipo?.id,
                            false
                        ),
                    handleWithConformityClick: () =>
                        handleRGRLDownload(
                            selectedItemFromAction?.id,
                            fileName,
                            selectedItemFromAction,
                            selectedItemFromAction?.tipo?.id,
                            true
                        ),
                    isLoading: isFetchingPDFLink
                })
            );
            return;

            // let response: any = null;
            // response = await triggerGetPresentacionRGRLPDFById({
            //     idPresentacion: selectedItemFromAction?.id,
            //     typeId: selectedItemFromAction?.tipo?.id
            // });

            // if (response?.error?.data?.statusCode === 404) {
            //     enqueueSnackbar(translate('table.enqueues.error.notFoundPDF'), {
            //         variant: 'error'
            //     });
            //     return;
            // }

            // if (response?.data?.data?.presignedUrls?.length >= 1) {
            //     response.data.data.presignedUrls.forEach((url: string, index: number) => {
            //         downloadBase64File(url, selectedItemFromAction.id, fileName, index);
            //         enqueueSnackbar(translate('table.enqueues.success.foundPDF'), {
            //             variant: 'success'
            //         });
            //     });
            // }
        } catch (error) {
        } finally {
            // setDownloadingPDF(false);
        }
    };

    const generateAndDownloadFiles = async () => {
        try {
            if (selectedPresentations?.length <= 0) {
                enqueueSnackbar(
                    translate('drawers.generateFilesSRT.enqueues.warning.noPresentationSelected'),
                    {
                        variant: 'warning'
                    }
                );
                return;
            }
            const presentationsIds = selectedPresentations.map((presentation) => presentation?.id);
            const adaptedBody: GenerateFilesBody = {
                idsPresentacion: presentationsIds
            };
            const response: any = await generateFiles(adaptedBody);
            if ('error' in response) {
                // 400/409 con mensaje para el usuario (p. ej. la tanda mezcla
                // aseguradoras o la aseguradora no tiene código): se muestra tal cual.
                const mensajeRechazo = obtenerMensajeRechazoGeneracion(response.error);
                if (mensajeRechazo) {
                    dispatch(
                        showAlert({
                            title: TITULO_ERROR_GENERACION,
                            message: mensajeRechazo,
                            icon: 'error',
                            confirmText: translate('buttons.accept')
                        })
                    );
                    return;
                }
                if (esErrorGenericoGeneracion(response.error)) {
                    enqueueSnackbar(
                        translate('drawers.generateFilesSRT.enqueues.error.somethingWentWrong'),
                        {
                            variant: 'error'
                        }
                    );
                    return;
                }
                throw response.error;
            }

            const presignedUrl = response?.data?.data?.presignedUrl;
            if (presignedUrl) {
                const todayDate = getCurrentDate();
                const formatDate = getDateTextFieldFormat(todayDate);
                const fileName = `${t('drawers.generateFilesSRT.filename')}_${formatDate}`;
                await downloadFile(presignedUrl, '.zip', fileName);
            }

            enqueueSnackbar(translate('drawers.generateFilesSRT.enqueues.success.generated'), {
                variant: 'success'
            });
            setSelectedPresentations([]);
            handleCloseDrawer();
        } catch (error) {
            dispatch(
                showAlert({
                    title: TITULO_ERROR_GENERACION,
                    message: ERROR_CONTACT_SUPPORT,
                    icon: 'error',
                    confirmText: ALERT_CONFIRM_TEXT
                })
            );
        }
    };

    const handleExportPresentations = async () => {
        try {
            // Los mismos filtros aplicados que muestra la grilla (sin paginado): el
            // endpoint de exportar acepta el filtro completo, no solo Cliente/Contrato.
            const params = buildRGRLExportParams(baseFilters, startDate, endDate);

            const response = await triggerExportPresentations(params).unwrap();
            const presignedUrl = (response as any)?.data?.presignedUrl;
            if (!presignedUrl) return;

            const todayDate = getCurrentDate();
            const formatDate = getDateTextFieldFormat(todayDate);
            await downloadFile(presignedUrl, '.xlsx', `GestionSRT_RGRL_${formatDate}`);
        } catch (error) {
            enqueueSnackbar(translate('alerts.exportRGRL.error'), { variant: 'error' });
        }
    };

    const handleRowClick = (selectedRowItem: any) => {
        setSelectedItemFromAction(selectedRowItem);
        setSelected(selectedRowItem);
        handleOpenCard();
    };

    const handleClickAction = (event: any, item: any, index: any) => {
        setSelectedItemFromAction(item);
        anchorToEventElement(event);
        openMenu();
    };

    const handleItemCheck = (selectedPresentation: SelectedPresentation) => {
        if (isPerfilBackOffice && !extraFilters?.idOrganizacion) {
            enqueueSnackbar(
                translate('drawers.generateFilesSRT.enqueues.warning.noOrganizationSelected'),
                {
                    variant: 'warning'
                }
            );
            return;
        }

        if (selectedPresentation?.estadoSRT === SRT_STATES.ERROR) return;

        const updatedSectors = selectedPresentations.some(
            (presentation) => presentation.id === selectedPresentation.id
        )
            ? selectedPresentations.filter(
                  (presentation) => presentation.id !== selectedPresentation.id
              )
            : [...selectedPresentations, selectedPresentation];

        setSelectedPresentations(updatedSectors);
    };

    const handleDateChange = (newStartDate: Date | null, newEndDate: Date | null) => {
        handleCloseDrawer();
        setDraftStartDate(newStartDate);
        setDraftEndDate(newEndDate);

        const isRangeComplete =
            Boolean(newStartDate) &&
            dayjs(newStartDate).isValid() &&
            Boolean(newEndDate) &&
            dayjs(newEndDate).isValid();

        if (isRangeComplete) {
            setStartDate(newStartDate);
            setEndDate(newEndDate);
            setFilters({
                ...filters,
                fechaInicio: newStartDate || undefined,
                fechaFin: newEndDate || undefined
            });
            handleSubmitSearch();
            return;
        }

        // Rango incompleto: si antes había un rango aplicado, se limpia para no
        // seguir filtrando por una fecha vieja mientras se completa la nueva.
        if (startDate || endDate) {
            setStartDate(null);
            setEndDate(null);
            handleSubmitSearch();
        }
    };

    const resetDateRange = () => {
        setStartDate(null);
        setEndDate(null);
        setDraftStartDate(null);
        setDraftEndDate(null);
    };

    return {
        filters,
        tableMenu,
        selectedItemFromAction,
        selected,
        FEATURES,
        selectedPresentations,
        presentations,
        isFetchingPresentations,
        isDownloadingPDF,
        isDownloading,
        isLoadingRgrl: isFetchingPDFLink,
        isGeneretingFiles,
        presentationUploadErrors,
        contractsOptions,
        isFetchingContractsOptions,
        establishmentsOptions,
        isFetchingEstablishmentsOptions,
        startDate,
        endDate,
        draftStartDate,
        draftEndDate,
        resetDateRange,
        handleDateChange,
        generateAndDownloadFiles,
        setSelectedPresentations,
        handleItemCheck,
        handleClickAction,
        handleRowClick,
        handleDownloadPresentation,
        handleExportPresentations,
        isExportingPresentations
    };
};

export default useFileGenerationRGRL;
